export default __webpack_public_path__ + "static/media/live_active.b54a9380.svg";